[
  {
    "code": "CA-AB",
    "name": "Alberta"
  },
  {
    "code": "CA-BC",
    "name": "British Columbia"
  },
  {
    "code": "CA-MB",
    "name": "Manitoba"
  },
  {
    "code": "CA-NB",
    "name": "New Brunswick"
  },
  {
    "code": "CA-NL",
    "name": "Newfoundland and Labrador"
  },
  {
    "code": "CA-NT",
    "name": "Northwest Territories"
  },
  {
    "code": "CA-NS",
    "name": "Nova Scotia"
  },
  {
    "code": "CA-NU",
    "name": "Nunavut"
  },
  {
    "code": "CA-ON",
    "name": "Ontario"
  },
  {
    "code": "CA-PE",
    "name": "Prince Edward Island"
  },
  {
    "code": "CA-QC",
    "name": "Quebec"
  },
  {
    "code": "CA-SK",
    "name": "Saskatchewan"
  },
  {
    "code": "CA-YT",
    "name": "Yukon Territory"
  }
]